import { theme } from '@prophecy/ui/theme';
import { Tooltip } from '@prophecy/ui/Tooltip';
import { castArray, flattenDeep } from 'lodash-es';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { TabError } from './hooks';

const StyledList = styled.ol`
  margin: 0;
  padding-inline-start: ${theme.spaces.x24};
`;

const getMessage = (error: string | boolean) => {
  return error === true ? 'Please fix form errors to continue' : error;
};

export const ErrorTooltip = ({
  errors,
  render
}: {
  errors?: TabError | (TabError | undefined)[];
  render: (hasErrors?: boolean) => ReactNode;
}) => {
  const errorList = flattenDeep<TabError | undefined>(castArray(errors || [])).filter(Boolean);

  if (errorList.length) {
    const tooltip =
      errorList.length > 1 ? (
        <>
          <StyledList>
            {errorList.map((error, index) => (
              <li key={index}>{getMessage(error)}</li>
            ))}
          </StyledList>
        </>
      ) : (
        getMessage(errorList[0])
      );

    return <Tooltip title={tooltip}>{render(true)}</Tooltip>;
  }

  return <>{render()}</>;
};
